import { useSession } from '../auth/useUser';

export function SignInPage() {
  const session = useSession();

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <div className="card w-full max-w-sm p-6 text-center">
        <h1 className="text-lg font-semibold tracking-tight">Jobshop</h1>
        <p className="mt-1 text-sm text-ink-500">
          Planning and tracking kitchen jobs through the shop.
        </p>

        {session.unauthorised ? (
          <p className="mt-4 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
            Signed in as <strong>{session.firebaseUser?.email}</strong>, but this shop does not
            know that address yet. Ask an administrator to add you.
          </p>
        ) : null}

        <div className="mt-6 flex flex-col gap-2">
          {session.firebaseUser ? (
            <button type="button" className="btn-secondary" onClick={() => void session.signOut()}>
              Sign out
            </button>
          ) : (
            <button type="button" className="btn-primary" onClick={() => void session.signIn()}>
              Sign in with Google
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
